import React from 'react'

const Spinner = () => (<div className="spinner spinner-2" />)

export default Spinner
